var SLASH;

import {
  setPre
} from 'x/route.js';

SLASH = '/';

export default (url) => {
  if (url.charAt(0) !== SLASH) {
    url = SLASH + url;
  }
  if (location.pathname === url) {
    return;
  }
  setPre(url.slice(1));
  history.pushState(null, '', url);
  window.dispatchEvent(new HashChangeEvent('hashchange'));
};
